import React, { useEffect, useState } from "react";
import DataTableBase from "../../common/DateTableBase";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../../utility";
import Loader from "../../common/Loader";
import { Col, Row } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const StaffList = () => {
    const navigate = useNavigate();

    const [staffList, setStaffList] = useState([]);
    const [filteredStaffList, setFilteredStaffList] = useState([]);
    const [flag, setFlag] = useState(2);
    const [delId, setDelId] = useState(null);
    const [show, setShow] = useState(false);

    const [loading, setLoading] = useState(true);

    const handleSearch = (e) => {
        const value = e.target.value;

        const filteredArray = staffList?.filter(item => item?.staff_vcard?.toLowerCase()?.includes(value.toLowerCase()) || item?.vin_id?.toLowerCase()?.includes(value?.toLowerCase()) || item?.volta?.toLowerCase()?.includes(value?.toLowerCase()) || item?.registration_no?.toLowerCase()?.includes(value?.toLowerCase()) || item?.rfid_no?.toLowerCase()?.includes(value?.toLowerCase()) || (item?.staff_status == "1" ? "Enable"?.toLowerCase()?.includes(value?.toLowerCase()) : "Disable"?.toLowerCase()?.includes(value?.toLowerCase()) ))
        // console.log(filteredArray);
        setFilteredStaffList(filteredArray);
    }
    
    useEffect(() => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/staff/list`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("staff list res : ", res);
            setStaffList(res?.data?.staffList);
            setFilteredStaffList(res?.data?.staffList);
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log("staff list error : ", err);
        })
    }, [flag])
    
    const delFunc = (idd) => {
        if(idd){
            setLoading(true);
            setShow(false);
            const token = localStorage.getItem("user_token");
            // console.log("token : ", token);
            axios.get(`${API_URL}/user/staff/delete/${idd}`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
                console.log("staff delete res : ", res);
                setFlag(flag + 1);
                setDelId(null);
                setLoading(false);
                toast.success("Staff deleted successfully");
            }).catch((err) => {
                setLoading(false);
                toast.error("Error");
                console.log("staff delete error : ", err);
            })
        }
    }

    const columns = [
        {
            name: <span className="tableHeaderText">No.</span>,
            width: '60px',
            selector: (row, index) => index + 1,
        },
        {
            name: <span className="tableHeaderText">Tools</span>,
            width: '140px',
            selector: row => <>
                <button className="btn-title ms-2" title="VCard Detail">
                    <svg onClick={() => navigate(`/vcard-detail/${row?.id}`)} className="pointer me-1 pt-1" xmlns="http://www.w3.org/2000/svg" width="34" height="30" viewBox="1600.797 306.958 32.083 25.667"><path d="M1616.036 314.979a4.012 4.012 0 0 0-4.01 4.01 4.012 4.012 0 0 0 4.01 4.01 4.012 4.012 0 0 0 4.01-4.01 4.012 4.012 0 0 0-4.01-4.01Zm13.636-8.021h-25.667a3.218 3.218 0 0 0-3.208 3.208v19.25a3.218 3.218 0 0 0 3.208 3.208h25.667a3.218 3.218 0 0 0 3.208-3.208v-19.25a3.218 3.218 0 0 0-3.208-3.208Zm-5.15 22.795-4.668-4.668a7.113 7.113 0 0 1-3.834 1.123c-3.978 0-7.202-3.225-7.202-7.219a7.21 7.21 0 0 1 7.218-7.219 7.21 7.21 0 0 1 7.22 7.219 7.154 7.154 0 0 1-1.124 3.834l4.668 4.652-2.277 2.278Z" fill="#197547" fill-rule="evenodd" data-name="Icon material-pageview"/></svg>
                </button>
                <button className="btn-title" title="Edit VCard">
                    <svg onClick={() => navigate(`/vcard/edit/${row?.id}`)} className="pointer mx-1" xmlns="http://www.w3.org/2000/svg" width="34" height="30" viewBox="1652.88 302.958 33.75 29.994"><path d="m1676.47 307.827 5.285 5.285a.573.573 0 0 1 0 .809l-12.797 12.797-5.437.603a1.14 1.14 0 0 1-1.26-1.26l.603-5.437 12.797-12.797a.573.573 0 0 1 .809 0Zm9.492-1.342-2.86-2.86a2.292 2.292 0 0 0-3.234 0l-2.074 2.075a.573.573 0 0 0 0 .809l5.285 5.285a.573.573 0 0 0 .809 0l2.074-2.075c.89-.896.89-2.343 0-3.234Zm-10.582 16.752v5.965h-18.75v-18.75h13.465a.72.72 0 0 0 .498-.205l2.344-2.344a.703.703 0 0 0-.499-1.201h-16.746a2.813 2.813 0 0 0-2.812 2.812v20.625a2.813 2.813 0 0 0 2.812 2.813h20.625a2.813 2.813 0 0 0 2.813-2.813v-9.246c0-.627-.756-.937-1.201-.498l-2.344 2.344a.72.72 0 0 0-.205.498Z" fill="#a72121" fill-rule="evenodd" data-name="Icon awesome-edit"/></svg>
                </button>
                {/* <button className="btn-title" title="">
                    <svg className="pointer mx-1" xmlns="http://www.w3.org/2000/svg" width="22.5" height="30" viewBox="1706.63 302.958 22.5 30"><path d="M1726.317 306.708h-4.687a3.753 3.753 0 0 0-3.75-3.75 3.753 3.753 0 0 0-3.75 3.75h-4.688a2.813 2.813 0 0 0-2.812 2.812v20.625a2.813 2.813 0 0 0 2.812 2.813h16.875a2.813 2.813 0 0 0 2.813-2.813V309.52a2.813 2.813 0 0 0-2.813-2.812Zm-14.062 21.094c-.78 0-1.406-.627-1.406-1.407 0-.779.627-1.406 1.406-1.406.78 0 1.406.627 1.406 1.406 0 .78-.627 1.407-1.406 1.407Zm0-5.625c-.78 0-1.406-.627-1.406-1.407 0-.779.627-1.406 1.406-1.406.78 0 1.406.627 1.406 1.406 0 .78-.627 1.407-1.406 1.407Zm0-5.625c-.78 0-1.406-.627-1.406-1.407 0-.779.627-1.406 1.406-1.406.78 0 1.406.627 1.406 1.406 0 .78-.627 1.407-1.406 1.407Zm5.625-11.25c.78 0 1.406.626 1.406 1.406 0 .78-.627 1.406-1.406 1.406-.78 0-1.406-.627-1.406-1.406 0-.78.627-1.406 1.406-1.406Zm7.5 21.562a.47.47 0 0 1-.469.469h-8.437a.47.47 0 0 1-.47-.469v-.937a.47.47 0 0 1 .47-.47h8.437a.47.47 0 0 1 .469.47v.937Zm0-5.625a.47.47 0 0 1-.469.469h-8.437a.47.47 0 0 1-.47-.469v-.937a.47.47 0 0 1 .47-.47h8.437a.47.47 0 0 1 .469.47v.937Zm0-5.625a.47.47 0 0 1-.469.469h-8.437a.47.47 0 0 1-.47-.469v-.937a.47.47 0 0 1 .47-.47h8.437a.47.47 0 0 1 .469.47v.937Z" fill="#303778" fill-rule="evenodd" data-name="Icon awesome-clipboard-list"/></svg>
                </button>
                <button className="btn-title" title="Delete VCard">
                    <svg onClick={() => {setDelId(row?.id); setShow(true);}} className="pointer ms-1" xmlns="http://www.w3.org/2000/svg" width="24.37" height="29.994" viewBox="1749.13 302.957 24.37 29.994"><path d="M1751.004 312.33v18.747a1.88 1.88 0 0 0 1.875 1.874h16.872a1.88 1.88 0 0 0 1.874-1.874V312.33h-20.62Zm5.624 16.872h-1.874v-13.123h1.874v13.123Zm3.75 0h-1.875v-13.123h1.875v13.123Zm3.749 0h-1.875v-13.123h1.875v13.123Zm3.75 0h-1.875v-13.123h1.874v13.123Zm4.217-22.496h-6.092v-2.343a1.41 1.41 0 0 0-1.406-1.406h-6.562a1.41 1.41 0 0 0-1.406 1.406v2.343h-6.092a1.41 1.41 0 0 0-1.406 1.406v2.344h24.37v-2.344a1.41 1.41 0 0 0-1.406-1.406Zm-7.967 0h-5.624v-1.85h5.624v1.85Z" fill="#303778" fill-rule="evenodd" data-name="Icon metro-bin"/></svg>
                </button> */}
            </>
        },
        {
            name: <span className="tableHeaderText">Reg No.</span>,
            selector: row => row?.registration_no,
            width: '120px',
            cell: row => {
                const displayRegNo = row.registration_no ? row.registration_no.split(/[,/]/)[0] : ''; //regex for plate number
                return <div title={row.registration_no}>{displayRegNo}</div>;
            }
        },
        {
            name: <span className="tableHeaderText">Status</span>,
            selector: row =>
            row?.staff_status === "1" ? (
                <span className="active-status">Enable</span>
            ) : row?.staff_status === "0" ? (
                <span className="inactive-status">Disable</span>
            ) : row?.staff_status === "Pending" ? (
                <span className="text-warning">Pending</span>
            ) : (
                <span className="text-secondary">Unknown</span>
            ),            
            width: '80px'
        },
        {
            // name: 'Points',
            name: <span className="tableHeaderText">Balance</span>,
            sortable: 'true',
            selector: row => row?.staff_wallet ? Number(row?.staff_wallet).toFixed(0) : 0,
            width: '100px',
        },        
        {   
            name: <span className="tableHeaderText">Total Top up</span>,
            selector: row => row?.fund_transfer_sum ? Number(row?.fund_transfer_sum).toFixed(0) : 0,
            sortable: 'true',
            width: '120px',
        },
        // {
        //     name: 'Staff Account',
        //     selector: row => row?.staff,
        // },
        // {
        //     name: 'Staff Account',
        //     selector: row => row?.staff,
        // },
        // {
        //     name: 'Name - Surname',
        //     selector: row => row?.name,
        // },
        {
            name: <span className="tableHeaderText">VIN</span>,
            width: 'auto',
            selector: row => row?.vin_id,
        },
        {
            name: <span className="tableHeaderText">VCard</span>,
            width: '200px',
            selector: row => row?.staff_vcard,
        },
        {
            name: <span className="tableHeaderText">RFID No.</span>,
            selector: row => row?.rfid_no,
            width: 'auto',
        },
        {
            name: <span className="tableHeaderText">Volta</span>,
            minWidth: '150px',
            selector: row => row?.volta,
            cell: row => {
                const voltaNum = row?.volta ? row?.volta.split(":")[1] : ''; //regex for volta number
                return <div title={row?.volta}>{voltaNum}</div>;
            }
        },
        {
            name: <span className="tableHeaderText">Model</span>,
            width: 'auto',
            selector: row => row?.model,
        },
        {
            name: <span className="tableHeaderText">Color Desc</span>,
            selector: row => row?.color_desc,
            width: 'auto',
        },
    ];

    return (
        <div className="stafflist-page">
            <ToastContainer />
            {show && (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Yes, delete it!"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="secondary"
                    title="Are you sure?"
                    onConfirm={() => {delFunc(delId);}}
                    onCancel={() => {setDelId(null); setShow(false);}}
                    focusCancelBtn
                >
                    You will not be able to recover this!
                </SweetAlert>
            )}

            <h1 className="stafflistHeader mt-3 pb-4">
                VCard List 
            </h1>

            <div className="d-flex justify-content-left mt-4 mb-3" style={{height: '42px'}} >
                <div className="p-relative">
                    <input className="searchBox" placeholder="Search..." onChange={handleSearch} type="text" style={{width: '300px'}} />
                    <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" width="23.062" height="23.062" viewBox="1764.938 75.468 23.062 23.062"><path d="M1774.937 75.497c-5.514 0-10 4.485-10 10 0 5.513 4.486 9.998 10 9.998 1.685 0 3.342-.4 4.742-1.171.112.135.237.26.372.371l2.856 2.857a2.914 2.914 0 1 0 4.114-4.114l-2.857-2.857a2.857 2.857 0 0 0-.457-.371c.772-1.4 1.257-3.028 1.257-4.742 0-5.514-4.485-10-9.999-10Zm0 2.857a7.109 7.109 0 0 1 7.142 7.142c0 1.886-.686 3.628-1.886 4.914l-.085.086c-.135.112-.26.236-.372.371-1.257 1.143-2.97 1.8-4.828 1.8a7.109 7.109 0 0 1-7.142-7.142 7.109 7.109 0 0 1 7.142-7.143Z" fill="#d2d2d2" fill-rule="evenodd" data-name="Icon open-magnifying-glass"/></svg>
                </div>
                <button className="pointerButton ms-4" onClick={() => navigate('/vcard/add')}>
                    Add VCard 
                    <svg className="ms-3" xmlns="http://www.w3.org/2000/svg" width="20.587" height="20.587" viewBox="838.955 86 20.587 20.587"><path d="M858.071 94.088h-6.617V87.47a1.47 1.47 0 0 0-1.47-1.47h-1.47a1.47 1.47 0 0 0-1.471 1.47v6.618h-6.617a1.47 1.47 0 0 0-1.47 1.47v1.47c0 .813.658 1.471 1.47 1.471h6.617v6.617c0 .812.658 1.47 1.47 1.47h1.47a1.47 1.47 0 0 0 1.471-1.47V98.5h6.617a1.47 1.47 0 0 0 1.47-1.47v-1.47a1.47 1.47 0 0 0-1.47-1.471Z" fill="#fff" fill-rule="evenodd" data-name="Icon awesome-plus"/></svg>
                </button>
            </div>

            {/* Enable status */}
            {/* <Row>
                <Col md={12} xl={4} className="d-flex justify-content-center align-items-center mt-3 mb-2">
                    <div className="statTextBox">
                        <h2>Total Result</h2>
                        <p>{filteredStaffList?.length} <span>Cards</span> </p>
                    </div>
                </Col>
                <Col md={6} xl={4} className="d-flex justify-content-center align-items-center mt-3 mb-2">
                    <div className="statTextBox">
                        <h2>Cards  <span style={{color:"#1ec06f"}}>Enabled</span></h2>
                        <p>12 <span>Cards</span> </p>
                    </div>
                </Col>
                <Col md={6} xl={4} className="d-flex justify-content-center align-items-center mt-3 mb-2">
                    <div className="statTextBox">
                        <h2>Cards <span style={{color:"#E8505B"}}>Disabled</span></h2>
                        <p>3 <span>Cards</span> </p>
                    </div>
                </Col>
            </Row> */}

            <div className="staff-table-div pt-3">
                {loading ? (
                    <Loader />
                ) : (
                    <DataTableBase 
                        columns={columns}
                        data={filteredStaffList}
                        pagination
                    />
                )}
            </div>
        </div>
    )
}

export default StaffList;